import { $_trans } from "vue-app/utils/functions";

export default {
  install(app, options) {
    app.config.globalProperties.$_trans = $_trans;
    app.config.globalProperties.trans = window._trans;
    app.provide("edroneTranslation", options);
  },
};
